module.exports = __webpack_public_path__ + "static/img/sd.30cf87d0.svg";